import { doesIdentityRequireRefresh, isIdentityExpired, memoizeIdentityProvider, } from "@smithy/core";
import { getSmithyContext, normalizeProvider, } from "@smithy/util-middleware";
/**
 * @internal
 */
export const defaultApiv2HttpAuthSchemeParametersProvider = async (config, context, input) => {
    return {
        operation: getSmithyContext(context).operation,
    };
};
function createSmithyApiHttpBearerAuthHttpAuthOption(authParameters) {
    return {
        schemeId: "smithy.api#httpBearerAuth",
        propertiesExtractor: ({ profile, filepath, configFilepath, ignoreCache, }, context) => ({
            /**
             * @internal
             */
            identityProperties: {
                profile,
                filepath,
                configFilepath,
                ignoreCache,
            },
        }),
    };
}
;
/**
 * @internal
 */
export const defaultApiv2HttpAuthSchemeProvider = (authParameters) => {
    const options = [];
    switch (authParameters.operation) {
        default:
            {
                options.push(createSmithyApiHttpBearerAuthHttpAuthOption(authParameters));
            }
            ;
    }
    ;
    return options;
};
/**
 * @internal
 */
export const resolveHttpAuthSchemeConfig = (config) => {
    const token = memoizeIdentityProvider(config.token, isIdentityExpired, doesIdentityRequireRefresh);
    return Object.assign(config, {
        authSchemePreference: normalizeProvider(config.authSchemePreference ?? []),
        token,
    });
};
